import React from 'react';
import { Route } from "react-router-dom";

import Login from './pages/auth/Login';
import Logout from './pages/auth/Logout';
import Register from './pages/auth/Register';

import Home from './pages/home/Home';
import Analytics from './pages/analytics/Analytics';
import MountainRanges from './pages/mountains/MountainRanges';

import Users from './pages/users/Users';
import CreateUser from './pages/users/CreateUser';
import EditUser from './pages/users/EditUser';
import EditBasicDetails from './pages/users/EditBasicDetails';
import EditPassword from './pages/users/EditPassword';

import Reports from './pages/reports/Reports';
import CreateReport from './pages/reports/CreateReport';
import EditReport from './pages/reports/EditReport';
import ViewAndPublishReport from './pages/reports/ViewAndPublishReport';
import ViewReportByDate from './pages/reports/ViewReportByDate';
import OverrideOutcome from './pages/reports/OverrideOutcome';

import ViewMainRangeReport from './pages/reports/ranges/ViewMainRangeReport';
import ViewDividingRangeReport from './pages/reports/ranges/ViewDividingRangeReport';
import ViewFrontRangeReport from './pages/reports/ranges/ViewFrontRangeReport';
import ViewSpringConditionsReport from './pages/reports/ranges/ViewSpringConditionsReport';

import EmbeddedCodePreview from './pages/reports/embedded/EmbeddedCodePreview';
import ViewSummarizedEmbeddedReport from './pages/reports/embedded/ViewSummarizedEmbeddedReport';
import ViewSummarizedEmbeddedReportFrontAndDividing from './pages/reports/embedded/ViewSummarizedEmbeddedReportFrontAndDividing';
import ViewSummarizedEmbeddedReportMainRange from './pages/reports/embedded/ViewSummarizedEmbeddedReportMainRange';
import ViewSummarizedLargeReport from './pages/reports/embedded/ViewSummarizedLargeReport';

// Single source of truth for browser-route -> page-component bindings.
// Add/remove routes here; nothing else in the app needs to change.
function AppRoutes() {
  return (
    <>
      <Route exact path="/" component={Home} />
      <Route path="/login" component={Login} />
      <Route path="/logout" component={Logout} />
      <Route path="/register" component={Register} />

      <Route path="/create-report" component={CreateReport} />
      <Route path="/edit-report/:id" component={EditReport} />
      <Route path="/view-and-publish-report/:id" component={ViewAndPublishReport} />
      <Route path="/override-outcome/:id" component={OverrideOutcome} />
      <Route path="/reports" component={Reports} />
      <Route path="/view-embedded-report" component={EmbeddedCodePreview} />

      <Route path="/view-spring-condition-report/:id" component={ViewSpringConditionsReport} />

      <Route exact path="/report" component={ViewReportByDate} />
      <Route path="/report/:id" component={ViewReportByDate} />

      <Route exact path="/main-range" component={ViewMainRangeReport} />
      <Route path="/main-range/:id" component={ViewMainRangeReport} />

      <Route exact path="/embedded-report-summary" component={ViewSummarizedEmbeddedReport} />
      <Route path="/embedded-report-summary/:id" component={ViewSummarizedEmbeddedReport} />

      <Route exact path="/embedded-report-summary-front-and-dividing-range" component={ViewSummarizedEmbeddedReportFrontAndDividing} />
      <Route path="/embedded-report-summary-front-and-dividing-range/:id" component={ViewSummarizedEmbeddedReportFrontAndDividing} />

      <Route exact path="/embedded-report-summary-large" component={ViewSummarizedLargeReport} />
      <Route path="/embedded-report-summary-large/:id" component={ViewSummarizedLargeReport} />

      <Route exact path="/embedded-report-summary-main-range" component={ViewSummarizedEmbeddedReportMainRange} />
      <Route path="/embedded-report-summary-main-range/:id" component={ViewSummarizedEmbeddedReportMainRange} />

      <Route exact path="/dividing-range" component={ViewDividingRangeReport} />
      <Route path="/dividing-range/:id" component={ViewDividingRangeReport} />

      <Route exact path="/front-range" component={ViewFrontRangeReport} />
      <Route path="/front-range/:id" component={ViewFrontRangeReport} />

      <Route path="/users" component={Users} />
      <Route path="/edit-user-basic-details" component={EditBasicDetails} />
      <Route path="/edit-user-password" component={EditPassword} />

      <Route path="/analytics" component={Analytics} />

      <Route path="/mountain-ranges" component={MountainRanges} />
      <Route path="/create-user" component={CreateUser} />
      <Route path="/edit-user/:id" component={EditUser} />
    </>
  );
}

export default AppRoutes;
